module.exports = __webpack_public_path__ + "media/images/homepage/play-icon-blue-ead2f5941f27c7d29901642205902172.png";